import _ from 'underscore';
import { createSelector } from 'reselect';
import addSelected from './selected_selector';

export default function makeEntitiesSelector(stateSelector, getAttributes, getAssociations) {
	
	getAttributes = getAttributes || function(entity) { return entity };
	getAssociations = getAssociations || (() => {});

	const create = createSelector(
		(entity, localState, associations) => entity,
		(entity, localState, associations) => localState,
		(entity, localState, associations) => associations,

		(entity, localState, associations) => Object.assign(
			{},
			entity,
			getAttributes(entity, localState, associations),
			addSelected(entity, 'selected', localState.selected),
			addSelected(entity, 'inspected', localState.inspected)
		)
	);

	const getState = stateSelector;

	const get = createSelector(
		(state, id) => stateSelector(state),
		(state, id) => getAssociations(state),
		(state, id) => id,
		(localState, associations, id) => {
			let entity;

			if(!localState.entities[id.toString()]) {
				console.log(`Could not find entity: ${id}`, localState);
			}
			else {
				entity = create(
					localState.entities[id.toString()],
					localState,
					associations
				);
			}

			return entity;
		}
	);

	const getAll = createSelector(
		state => stateSelector(state),
		state => getAssociations(state),
		(localState, associations) => localState.items.map(id => create(
			localState.entities[id.toString()],
			localState,
			associations
		))
	);

	const getSelected = createSelector(
		state => getAll(state),
		state => stateSelector(state).selected,
		(entities, selected) => entities.filter(entity => entity.selected)
	);

	const filter = createSelector(
		(state, filters) => getAll(state),
		(state, filters) => filters,
		(items, predicate) => {
			return _.filter(items, predicate) || [];
		}
	);

	const getInspected = createSelector(
		state => getAll(state),
		(entities) => entities.filter(entity => entity.inspected)
	);

	return {
		create: create,
		getState: getState,
		get: get,
		getAll: getAll,
		filter: filter,
		getSelected: getSelected,
		getInspected: getInspected
	}
};


/** WEBPACK FOOTER **
 ** ./src/js/selectors/entities_selector.js
 **/